<template>
    <div class="text" v-html="text" @click="draw"></div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
/* eslint-disable no-empty-function */
import { isLogin } from '../../utils';

export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        remain: {
            type: Number,
            default: 0
        },
        drawCb: {
            // 抽奖回调
            type: Function,
            require: true,
            default: () => {}
        },
        drawSuccessCb: {
            // 抽奖成功回调
            type: Function,
            default: () => {}
        },
        drawFailCb: {
            // 抽奖失败回调
            type: Function,
            default: () => {}
        },
        noRemainCb: {
            // 无抽奖机会的回调
            type: Function,
            default: () => {}
        },
        noLoginCb: {
            // 未登录时点击按钮
            type: Function,
            default: () => {}
        },
        multiDrawCb: {
            // 一键十抽回调
            type: Function,
            default: () => {}
        },
        multiDrawSuccessCb: {
            // 一键十抽成功回调
            type: Function,
            default: () => {}
        },
        multiDrawFailCb: {
            // 一键十抽失败回调
            type: Function,
            default: () => {}
        },
        lottieModalRef: {
            type: Object,
            default: null
        }
    },
    data() {
        return {};
    },
    methods: {
        /**
         * 抽奖
         */
        async draw() {
            // 未登录
            if (!isLogin) {
                if (this.noLoginCb) {
                    this.noLoginCb();
                }
                return;
            }
            // 没有抽奖机会
            if (!this.remain) {
                if (this.noRemainCb) {
                    this.noRemainCb();
                }
                return;
            }

            try {
                // 开始动画播放
                if (this.lottieModalRef) {
                    await this.lottieModalRef.playStartAndLoopAnimation();
                }

                // 抽奖
                const res = await this.drawCb();

                // 抽奖成功，播放结束动画
                if (this.lottieModalRef) {
                    await this.lottieModalRef.playEndAnimationAndClose();
                }
                this.drawSuccessCb(res);
            } catch (error) {
                // 抽奖失败，关闭动画弹窗
                if (this.lottieModalRef) {
                    await this.lottieModalRef.close();
                }
                this.drawFailCb(error);
            }
        },
        /**
         * 一键十抽
         */
        async multiDraw() {
            // 未登录
            if (!isLogin) {
                if (this.noLoginCb) {
                    this.noLoginCb();
                }
                return;
            }
            // 没有抽奖机会
            if (!this.remain) {
                if (this.noRemainCb) {
                    this.noRemainCb();
                }
                return;
            }

            try {
                // 开始动画播放
                if (this.lottieModalRef) {
                    await this.lottieModalRef.playStartAndLoopAnimation();
                }

                // 抽奖
                const res = await this.multiDrawCb();

                // 抽奖完成，播放结束动画
                if (this.lottieModalRef) {
                    await this.lottieModalRef.playEndAnimationAndClose();
                }
                const isSuccess = res.every((item) => item.prizeId !== null);
                if (isSuccess) {
                    this.multiDrawSuccessCb(res);
                } else {
                    this.multiDrawFailCb(res);
                }
            } catch (error) {
                if (this.lottieModalRef) {
                    await this.lottieModalRef.close();
                }
                this.drawFailCb(error);
            }
        }
    }
};
</script>

<style lang="less" scoped></style>
